import { TrashClearKit } from 'education-icons';
import { Button, SimpleText } from 'platform-components';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';

interface StoreProps {
    clessonId: number | null;
}

interface DispatchProps {
    deleteCLessonAsync: typeof lessonViewActions.deleteCLessonAsync;
}

interface Props extends StoreProps, DispatchProps {}

const DeleteButton = (props: Props) => {
    const { clessonId, deleteCLessonAsync } = props;

    const courseId = useSelector(getCurrentYearCourseId);
    const activeSubscriptionSlug = useSelector((store) => {
        return lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId });
    });

    const handleClick = async () => {
        if (clessonId) {
            await deleteCLessonAsync({ cLessonId: clessonId });
            ym('reachGoal', 'button_delete_lesson', {
                clessonId,
                subscription_slug: activeSubscriptionSlug,
            });
        }
    };

    return (
        <Button
            className="lesson-view__delete-button lesson-view__header-button"
            icon={<TrashClearKit />}
            onClick={handleClick}
            view={Button.VIEW.SECONDARY}
        >
            <SimpleText id="lessonView.button.deleteLesson" />
        </Button>
    );
};

const mapStateToProps = (storeState: any): StoreProps => ({
    clessonId: lessonSelectors.getCLessonId(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            deleteCLessonAsync: lessonViewActions.deleteCLessonAsync,
        },
        dispatch
    );
};

const button = connect(mapStateToProps, mapDispatchToProps)(DeleteButton);

button.displayName = 'DeleteButton';

export default button;
